<!--<form #form="ngForm">-->
<p-panel>	
	<his-plam>
	    <his-file-upload
	        #content
	        [(ngModel)]="uploadFiles"
	        configKey="fs.res.publication.import.bibtex">
		</his-file-upload>
	</his-plam>
	
	<button [disabled]="uploadFiles.length === 0"
		(click)="doImport(uploadFiles[0])"
		hisImage="LINE_OUT"
		class="transparent">
		<span>{{'fs.res.publication.import.start' | hisUi}}</span>
	</button>
</p-panel>